// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2-mS-","disabled":"FileBtn_disabled__3qw4W","warn":"FileBtn_warn__313c6","fade":"FileBtn_fade__2fCDG"};